export const getFilteredNameValue = (value: string) => (value?.length < 200 ? value : 'pen-test');
